import React, { useEffect, useRef, useState } from "react";
import CardWithShadow from "../../../common/CardWithShadow";
import Contact from "../../../template-parts/Contact";
import "./MultiScreenContainer.css";
import { useLoader } from "../../../../hooks/Loader";
import { AppContext } from "../../../core/ApplicationContextProvider";
import { CustomScreenViewer } from "../CustomScreenViewer/CustomScreenViewer";
import { MultiScreenViewer } from "../MultiScreenViewer/MultiScreenViewer";
import type { AppContextType } from "../../../core/types";
import type { Loader } from "../../../../hooks/Loader";

const MultiScreenContainer: React.FC = () => {
  const {
    details,
    bgHook,
    setApplicationError,
    currentScreen,
    resolveScreenAction,
  } = React.useContext(AppContext) as AppContextType;
  bgHook.setDynamicPage();
  const loader = useLoader(false) as Loader;
  const cardRef = useRef<HTMLDivElement>(null);
  
  function onSubmit(data: Record<string, any>) {
    loader.setLoading();
    resolveScreenAction(data)
      .then(() => {
        loader.setSuccess();
      })
      .catch(() => {
        loader.setError();
        setApplicationError();
      });
  }
  
  const [height, setHeight] = useState(400);

  useEffect(() => {
    setHeight(cardRef.current ? cardRef.current.clientHeight : 400);
  });
  
  const useSmallLayout = height < 400;
  const contactCardClasses = useSmallLayout ? "col-md-12" : "col-md-6";

  if (!currentScreen) {
    return <></>;
  }

  return (
    <div className="container pt-3 mb-md-5 pl-0 pr-0 update-element mt-md-5">
      <div className="row mt-5 mb-2 m-right-sm flex-row-reverse">
        <div className="col-md-6 pr-0 pt-1 mt-5 mt-md-0">
          {/* @ts-ignore */}
          <CardWithShadow ref={cardRef}>
            <div className="card-body">
              {currentScreen.type === "standard" ? (
                <MultiScreenViewer onSubmit={onSubmit} loader={loader} />
              ) : (
                <CustomScreenViewer screen={currentScreen.name} />
              )}
            </div>
          </CardWithShadow>
        </div>
        <div
          className={
            "pt-1 ml-3 ml-md-0 d-flex flex-column-reverse " + contactCardClasses
          }
        >
          <div className="row">
            <Contact
              businessLineDetails={details?.businessLineDetails}
              firstRowSize={useSmallLayout ? null : 12}
              secondRowSize={useSmallLayout ? null : 12}
              inlineInfo={!useSmallLayout}
              noMarginBottomLarge={true}
              noMarginBottomSmall={true}
              campaignDetails={details?.campaignDetails}
            />
          </div>
        </div>
      </div>

      <div className="row mb-5 d-none d-md-block">
        <div className="col-8 mb-5">
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

export default MultiScreenContainer;
